import { useUserBalances } from '@givebacks/api/ledger';
import { ClickableOptionsCard, TransferAccountsModalGroup } from 'core/Components';
import { centsToDollar } from 'ui';
import { IconRewardsLeft } from 'ui/Icons';

const AccountBalance = () => {
  const { data: balance } = useUserBalances();

  return (
    <TransferAccountsModalGroup
      openButton={(props) => (
        <ClickableOptionsCard.Row
          title={balance?.available ? centsToDollar(balance.available) : '$0.00'}
          subtitle="Available Rewards Balance"
          leftSection={<IconRewardsLeft size={42} />}
          onClick={() => props.openModalById('AvailableBalance')}
        />
      )}
    />
  );
};

export { AccountBalance };
